module.exports = __webpack_public_path__ + "html/comment-form.template.html";